import React, { memo } from 'react';
import { View } from 'react-native';
import Amount from 'design-system/Amount';
import Text from 'design-system/Text';
import { CardView, ProgressBar, Spacer, ToolTip } from 'design-system';
import useColors from 'hooks/useColors';
import useStyles from 'hooks/useStyles';
import { useAppSelector } from 'store/hooks';
import createStyleSheets from 'utils/createStyleSheets';
import { selectTradingAccount } from '../reducers/selectors';
import { JisaAllowanceDescription, JisaAllowanceNumeric } from '../constants';
const strings = {
    jisaAllowance: 'Junior ISA allowance',
    jisaAllowanceLeft: 'JISA allowance left',
    basedOnThisYear: 'Based on this tax year',
};
const JISAAllowanceInfo = () => {
    const colors = useColors();
    const styles = useStyles(styleSet);
    const tradingAccount = useAppSelector(selectTradingAccount);
    const remainingAllowance = tradingAccount?.account.accountType === 'JISA'
        ? tradingAccount?.account.jisaRemainingAllowanceAfterPending
        : undefined;
    if (!remainingAllowance) {
        return null;
    }
    const effectiveValue = Math.max(0, remainingAllowance.value);
    const progress = Math.max(0, 1 - effectiveValue / JisaAllowanceNumeric);
    return (<CardView noMarginTop withPadding>
      <View style={styles.row}>
        <Text Text-16 flex>
          {strings.jisaAllowanceLeft}
        </Text>
        <Amount Numbers-16 value={{ value: effectiveValue, currency: 'GBP' }}/>
      </View>
      <Spacer h={8}/>
      <ProgressBar animateInitial={false} animateProgress={false} position={progress * 100} colors={colors.gradients.ultimate.colors}/>
      <Spacer h={8}/>
      <View style={styles.row}>
        <Text TextThin-14 Secondary>
          {strings.basedOnThisYear}
        </Text>
        <Spacer w={4}/>
        <ToolTip small offset={1} colorKey="secondary" title={strings.jisaAllowance} subtitle={JisaAllowanceDescription}/>
      </View>
    </CardView>);
};
const styleSet = createStyleSheets(() => ({
    row: {
        alignItems: 'center',
        flexDirection: 'row',
    },
    flex: {
        flex: 1,
    },
}));
export default memo(JISAAllowanceInfo);
